import React, { useState, useEffect, useContext, useMemo } from "react";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form, FormControl, Button } from "react-bootstrap";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import MyContext from "../../../../MyContext";
import rightArrow from "../../../../images/Arrow - Right.svg";
import downArrow from "../../../../images/Arrow - Down.svg";
import OtherPaymentMethod from "./OtherPaymentMethod";
import Customization from "./Customization";
const OrderSettings = ({ userID }) => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("discounts");
  const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);


  const [chargesData, setChargesData] = useState([]);
  const [discountsList, setDiscountsList] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [deliveryData, setDeliveryData] = useState({
    userid: "",
    charges: "",
    fromAmount: "",
    toAmount: "",
    chargeType: "",
  });

  // Discount Payload
  const [discountData, setDiscountData] = useState({
    userid: "",
    discount: "",
    discountType: "",
    orderType: "",
  });

  
 
 


 
const [printSettingData, setPrintSettingData] = useState({
  normalFontSize: "",
  largeFontSize: "",
  pageWidth: "",
  anlookActive: false,  
  autoPrint: false      
});
const [printSettingDetails, setPrintSettingDetails] = useState(null);
  const isEmptyOrWhitespace = (value) => !value || !value.trim();
  const isNumber = (value) => !isNaN(value) && value.trim() !== "";
  const handleDeliveryChange = (e) => {
    setDeliveryData({ ...deliveryData, [e.target.name]: e.target.value });
  };
const handlePrintSettingChange = (e) => {
  const { name, value, type, checked } = e.target;

  setPrintSettingData((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value,
  }));
};

  const handleDiscountChange = (e) => {
    setDiscountData({ ...discountData, [e.target.name]: e.target.value });
  };

 
 
  const handleUpdateDiscount = async () => {
    const {
      discount,
      fromAmount,
      toAmount,
      discountType,
      orderType,
      maxDiscount,
    } = discountData;

    if (
      isEmptyOrWhitespace(userID) ||
      isEmptyOrWhitespace(discount) ||
      !isNumber(discount) ||
      isEmptyOrWhitespace(discountType) ||
      isEmptyOrWhitespace(orderType)
    ) {
      toast.error(
        " Please fill all fields correctly. Discount and Amounts must be numeric."
      );
      return;
    }

    setLoading(true);
    try {
      const requestBody = {
        userid: userID.trim(),
        discount: discount.trim(),
        chargeType: discountType.trim(),
        orderType: orderType.trim(),
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updatePosDiscount`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          ` ${
            response?.data?.responseMessage || "Discount updated successfully."
          }`
        );
  getDiscountApi();
       
        // getChargesApi();
      } else {
        toast.error(
          ` ${response?.data?.responseMessage || "Failed to update discount."}`
        );
      }
    } catch (error) {
      toast.error("Error updating discount. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  
  const getDiscountApi = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v2.0/getPosDiscountList`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {

        setDiscountsList(response.data.response);

     
      } else {
        // toast.error(
        //   `${
        //     response?.data?.responseMessage ||
        //     "Failed to update delivery charges."
        //   }`
        // );
      }
    } catch (error) {
      toast.error("Error updating delivery charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  
 


const handleUpdatePrintSetting = async () => {
  const { normalFontSize, largeFontSize, pageWidth, anlookActive, autoPrint } = printSettingData;

  if (![normalFontSize, largeFontSize, pageWidth].every(isNumber)) {
    toast.error("Please enter valid numeric values for all fields.");
    return;
  }

  setLoading(true);

  try {
    const requestBody = {
      userid: userID,
      printConfig: [
        { key: "normalFontSize", value: normalFontSize },
        { key: "largeFontSize", value: largeFontSize },
        { key: "pageWidth", value: pageWidth },
        { key: "anlookActive", value: anlookActive ? "1" : "0" },
        { key: "autoPrint", value: autoPrint ? "1" : "0" }
      ]
    };

    const response = await axios.post(
      `${baseUrl}/api/Order/v1.0/updatePrintSettings`,
      requestBody,
      config
    );

    if (response.data.responseCode === "00") {
      toast.success(response?.data?.responseMessage || "Print settings updated successfully.");
      setPrintSettingData({
        normalFontSize: "",
        largeFontSize: "",
        pageWidth: "",
        anlookActive: false,
        autoPrint: false
      });
      reciptDetailsApi();
    } else {
      toast.error(response?.data?.responseMessage || "Failed to update print settings.");
    }
  } catch (error) {
    toast.error("Error occurred. Please try again.");
  } finally {
    setLoading(false);
  }
};



 const reciptDetailsApi = async () => {
  try {
    const response = await axios.post(`${baseUrl}/api/Order/getReceiptData`, {
      userid: userID,
    },config);

    if (response.data.responseCode === "00") {
      const data = response.data.response[0];

      // Parse printSettings here, ensuring it's always an array
      let parsedSettings = [];
      if (data.printSettings) {
        try {
          parsedSettings = typeof data.printSettings === "string"
            ? JSON.parse(data.printSettings)
            : data.printSettings;
        } catch (error) {
          console.error("Failed to parse printSettings:", error);
        }
      }

      setPrintSettingDetails({
        autoPrint: data.autoPrint,
        printOn: data.printOn,
        printOption: data.printOption,
        printSettings: parsedSettings,
      });
    } else {
      console.error("Failed to fetch print settings, responseCode:", response.data.responseCode);
    }
  } catch (error) {
    console.error("Error fetching print settings:", error);
  }
};

  useEffect(() => {
    reciptDetailsApi();
    getDiscountApi();
    // fetchOrganizationDetails();
  }, []);
 useEffect(() => {
  if (printSettingDetails?.printSettings && typeof printSettingDetails.printSettings === "string") {
    try {
      const parsedSettings = JSON.parse(printSettingDetails.printSettings);
      setPrintSettingDetails(prev => ({
        ...prev,
        printSettings: parsedSettings,
      }));
    } catch (err) {
      console.error("Failed to parse printSettings:", err);
    }
  }
}, [printSettingDetails]);

  










  const handleDeleteDiscount = async (discountId) => {
    try {
      const requestBody = {
        userid: userID,
        discountId: discountId,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/deletePosDiscount`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(response?.data?.responseMessage);
        getDiscountApi();
      } else {
        toast.error(`${response?.data?.responseMessage || "Failed to remove"}`);
      }
    } catch (error) {
      // toast.error("Error updating delivery charges. Please try again.");
    }
  };
  const handleDeleteDeliveryCharges = async (chargeId) => {
    try {
      const requestBody = {
        userid: userID,
        chargeId: chargeId,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/deleteDeliveryCharges`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(response?.data?.responseMessage);

      } else {
        toast.error(`${response?.data?.responseMessage || "Failed to remove"}`);
      }
    } catch (error) {
      // toast.error("Error updating delivery charges. Please try again.");
    }
  };


  const [orderCharges, setOrderCharges] = useState([]);
  const getOrderChargesApi = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getOrderCharges`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        setOrderCharges(response.data.response);
      } else {
      }
    } catch (error) {
      // toast.error("Error updating delivery charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  // new Order Chagrge Payload
  const [newOrderCharge, setNewOrderCharge] = useState({
    userid: "",
    discount: "",
    fromAmount: "",
    toAmount: "",
    chargeType: "",
    chargeOn: "",
  });
  const handleOrderChargeChange = (e) => {
    const { name, value } = e.target;
    setNewOrderCharge((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleUpdateOrderCharges = async () => {
    const { userid, charges, fromAmount, toAmount, chargeType } =
      newOrderCharge;
    if (isEmptyOrWhitespace(chargeType)) {
      toast.error(
        "Please fill all fields correctly. Charges and Amounts must be numeric."
      );
      return;
    }
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
        charges: "",
        fromAmount: "",
        toAmount: "",
        chargeType: "",
        chargeOn: chargeType, // or any appropriate static/dynamic value
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateOrderCharges`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        toast.success(
          response.data.responseMessage || "Order charges updated successfully."
        );
        // Reset form
        setNewOrderCharge({
          userid: userID,
          charges: "",
          fromAmount: "",
          toAmount: "",
          chargeType: "",
        });
        getOrderChargesApi();
      } else {
        toast.error(
          response.data.responseMessage || "Failed to update charges."
        );
      }
    } catch (error) {
      toast.error("Error updating charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getOrderChargesApi();
  }, []);
  const [catalogueStore, setCatalogueStore] = useState([]);
  const allcatalogueAPI = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
        secret: "string",
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getMerchantMenuItems`,
        requestBody,
        config
      );
      console.log(response.data.response);
      if (response.data.responseCode === "00") {
        setCatalogueStore(response.data.response);
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    allcatalogueAPI();
  }, []);

  const filteredCategories = useMemo(() => {
    if (!catalogueStore) return [];
    return catalogueStore
      .map((category) => {
        const filteredItems = (category.menu_items || []).filter((item) =>
          item?.item_name?.toLowerCase().includes(searchText.toLowerCase())
        );
        return {
          ...category,
          menu_items: filteredItems, // make sure to keep it as `menu_items` so your component works
        };
      })
      .filter((category) => category.menu_items.length > 0); // remove empty categories
  }, [catalogueStore, searchText]);
  useEffect(() => {
    if (searchText.trim()) {
      const matchedIds = filteredCategories.map((cat) => String(cat.cat_id));
      setExpandedCategories(matchedIds);
    } else {
      // Optional: collapse all
      const firstCatId = String(catalogueStore?.[0]?.cat_id || "");
      setExpandedCategories(firstCatId ? [firstCatId] : []);
    }
  }, [filteredCategories, searchText, catalogueStore]);

  return (
    <>
    {/* {JSON.stringify(discountsList)} */}
      <div className="d-flex justify-content-center text-center">
        <ToastContainer />
      </div>
      <div>
        <div
          className="p-4 bg-white"
          style={{
            height: "100vh",
            fontFamily: "Nunito,sans-serif",
          }}
        >
          <div className="px-4 justify-content-center">
            <Form className="d-flex justify-content-between pb-4">
              <Form.Label className="CreateCampaign">POS Order Settings</Form.Label>
            </Form>
            {/* Tab Headers */}
            <ul className="nav nav-tabs mb-4 bg-light p-2 rounded shadow-sm">
              {[
                // { key: "deliveryCharges", label: "Delivery Charges" },
                // { key: "services", label: "Services" },

                { key: "discounts", label: "Discounts" },
                { key: "customization", label: "Customization" },
                { key: "paymentmethod", label: "Payment Method" },
                // { key: "free", label: "Free Items" },
                // { key: "orderCharges", label: "Order Charges" },
                // { key: "orderTiming", label: "Order Timing" },
                { key: "printing", label: "Receipt Printing" },
              ].map((tab) => (
                <li className="nav-item" key={tab.key}>
                  <button
                    className={`nav-link fw-semibold rounded-top px-3 py-2 mx-1 ${
                      activeTab === tab.key
                        ? "active order-section-button bg-green-order  text-white"
                        : "text-dark bg-light"
                    }`}
                    onClick={() => setActiveTab(tab.key)}
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
            {/* Tab Contents */}
            {loading ? (
              <div className="m-5 p-5 d-flex justify-content-center">
                <div className="loader"></div>
              </div>
            ) : (
              <>
                {/* Order Charges Tab */}
             

{/* services Tab */}


                {/* Delivery Charges Tab */}
                {activeTab === "deliveryCharges" && (
                  <div className="row">
                    <div className="col-12">
                      {/* Current Delivery Charge Display */}
                      {chargesData.map((charge, index) => (
                        <div key={index} className="col">
                          <div className="p-4 bg-white w-100  border rounded-4 mb-3">
                            <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                              <h5 className="fw-semibold text-success ">
                                Currently Applied Delivery Charges
                              </h5>
                              <div>
                                <button
                                  className="btn btn-danger"
                                  onClick={() => {
                                    handleDeleteDeliveryCharges(charge.id);
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                            <div className="d-flex flex-column gap-2">
                              <div className="d-flex justify-content-between">
                                <span className="text-muted">Charges:</span>
                                <span className="fw-medium text-dark">
                                  {charge.charge_type === "fixed" ? "₹" : ""}
                                  {parseFloat(charge.charges).toFixed(2)}
                                  {charge.charge_type === "fixed" ? "" : "%"}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between">
                                <span className="text-muted">Type:</span>
                                <span className="fw-medium text-dark">
                                  {charge.charge_type}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between">
                                <span className="text-muted">From:</span>
                                <span className="fw-medium text-dark">
                                  ₹{parseFloat(charge.from_amt).toFixed(2)}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between">
                                <span className="text-muted">To:</span>
                                <span className="fw-medium text-dark">
                                  ₹{parseFloat(charge.to_amt).toFixed(2)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}

                      <div className="p-4 bg-light border-0  rounded-4 mb-5">
                        <h5 className="fw-semibold text-success mb-4">
                          {" "}
                          Update Delivery Charges
                        </h5>
                        <div className="row g-4">
                          <div className="col-md-6">
                            <label className="form-label">Charges</label>
                            <input
                              type="text"
                              className="form-control"
                              name="charges"
                              value={deliveryData.charges}
                              onChange={handleDeliveryChange}
                              placeholder="Enter Charges"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">From Amount</label>
                            <input
                              type="text"
                              className="form-control"
                              name="fromAmount"
                              value={deliveryData.fromAmount}
                              onChange={handleDeliveryChange}
                              placeholder="Enter From Amount"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">To Amount</label>
                            <input
                              type="text"
                              className="form-control"
                              name="toAmount"
                              value={deliveryData.toAmount}
                              onChange={handleDeliveryChange}
                              placeholder="Enter To Amount"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Charge Type</label>
                            <select
                              className="form-control"
                              name="chargeType"
                              value={deliveryData.chargeType}
                              onChange={handleDeliveryChange}
                            >
                              <option value="">Select Charge Type</option>
                              <option value="fixed">Fixed</option>
                              <option value="percentage">Percentage</option>
                            </select>
                          </div>
                        </div>
                        {/* <div>
                          <button
                            className="btn btn-success mt-4"
                            onClick={handleUpdateDeliveryCharges}
                            disabled={loading}
                          >
                            {loading
                              ? "Updating..."
                              : "Update Delivery Charges"}
                          </button>
                        </div> */}
                      </div>
                    </div>
                  </div>
                )}

                {/* Discounts Tab */}
                {activeTab === "discounts" && (
                  <div className="row">
                    <div className="col-12">
                      {/* Current Discount Display */}
                      {discountsList.length > 0 ? (
                        <>
                          {discountsList.map((discount, index) => (
                            <div key={index} className="col">
                              <div className="p-4 bg-white w-100  border rounded-4 mb-3">
                                <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                                  <h5 className="fw-semibold text-success ">
                                    Currently Applied Discount
                                  </h5>
                                  <div>
                                    <button
                                      className="btn btn-danger"
                                      onClick={() => {
                                        handleDeleteDiscount(discount.id);
                                      }}
                                    >
                                      Remove
                                    </button>
                                  </div>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">
                                      Discount:
                                    </span>
                                    <span className="fw-medium text-dark">
                                      {discount.discountType === "fixed"
                                        ? "₹"
                                        : ""}
                                      {parseFloat(discount.discount).toFixed(2)}
                                      {discount.discountType === "fixed"
                                        ? ""
                                        : "%"}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">Discount Type:</span>
                                    <span className="fw-medium text-dark">
                                      {discount.discountType}
                                    </span>
                                  </div>
                                 
                                
                                

                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">
                                      Order Type:
                                    </span>
                                    <span className="fw-medium text-dark">
                                      {discount.orderType}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </>
                      ) : (
                        <></>
                      )}

                      <div className="p-4 bg-light border-0  rounded-4">
                        <h5 className="fw-semibold text-success mb-4">
                          Update Discount
                        </h5>
                        <div className="row g-4">
                          <div className="col-md-6">
                            <label className="form-label">Discount</label>
                            <input
                              type="text"
                              className="form-control"
                              name="discount"
                              value={discountData.discount}
                              onChange={handleDiscountChange}
                              placeholder="Enter Discount"
                            />
                          </div>
                        
                        
                         

                          <div className="col-md-6">
                            <label className="form-label">Discount Type</label>
                            <select
                              className="form-control"
                              name="discountType"
                              value={discountData.discountType}
                              onChange={handleDiscountChange}
                            >
                              <option value="">Select Discount Type</option>
                              <option value="fixed">Fixed</option>
                              <option value="percentage">Percentage</option>
                            </select>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Order Type</label>
                            <select
                              className="form-select"
                              name="orderType"
                              value={discountData.orderType}
                              onChange={handleDiscountChange}
                            >
                              <option value="">Select Order Type</option>
                              <option value="homeDelivery">
                                Home Delivery
                              </option>
                              <option value="takeaway">Takeaway</option>
                              <option value="dining">Dining</option>
                            </select>
                          </div>
                        </div>
                        <div>
                          <button
                            className="btn btn-success mt-4 "
                            onClick={handleUpdateDiscount}
                            disabled={loading}
                          >
                            {loading ? "Updating..." : "Update Discount"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
{activeTab === "paymentmethod" && (
<>
<OtherPaymentMethod userID={userID} />
</>
)}
{activeTab === "customization" && (
<>
<Customization userID={userID} />
</>
)}

            
                {/* Receipt Printing Tab */}
{activeTab === "printing" && (
  <div className="row">
    <div className="col-6">
      {printSettingDetails ? (
        <div className="col">
          <div className="p-4 bg-white w-100 border rounded-4 mb-3">
            <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
              <h5 className="fw-semibold text-success mb-0">Print Settings</h5>
            </div>

            <div className="d-flex flex-column gap-2">
            <div className="d-flex flex-column gap-2">
  <div className="d-flex justify-content-between">
    <span className="text-muted">Use Anlook Printing Software:</span>
    <span className="fw-medium text-dark">
      {printSettingDetails?.printSettings?.find(p => p.key === "anlookActive")?.value === "1"
        ? "Enabled"
        : "Disabled"}
    </span>
  </div>

  <div className="d-flex justify-content-between">
    <span className="text-muted">Auto-Print Receipts:</span>
    <span className="fw-medium text-dark">
      {printSettingDetails?.printSettings?.find(p => p.key === "autoPrint")?.value === "1"
        ? "Enabled"
        : "Disabled"}
    </span>
  </div>

  <div className="d-flex justify-content-between">
    <span className="text-muted">Receipt Print Mode:</span>
    <span className="fw-medium text-dark">
      {printSettingDetails?.printSettings?.find(p => p.key === "autoPrint")?.value === "1"
        ? "Print automatically after payment"
        : "Manual print with one click"}
    </span>
  </div>
</div>

              <hr />

              {printSettingDetails?.printSettings?.slice(0, 3).map((setting, idx) => (
                <div key={idx} className="d-flex justify-content-between">
                  <span className="text-muted">{setting.key}:</span>
                  <span className="fw-medium text-dark">{setting.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="text-center text-danger mb-4">
          No print setting data found.
        </div>
      )}

      <div className="p-4 bg-light border-0 rounded-4">
        <h5 className="fw-semibold text-success mb-4">Update Printing Setting</h5>
        <div className="row g-4">
          <div className="col-md-12">
            <label className="form-label">Normal Font Size (PX)</label>
            <input
              type="text"
              className="form-control"
              name="normalFontSize"
              value={printSettingData.normalFontSize}
              onChange={handlePrintSettingChange}
              placeholder="Enter Normal Font Size"
            />
          </div>
          <div className="col-md-12">
            <label className="form-label">Large Font Size (PX)</label>
            <input
              type="text"
              className="form-control"
              name="largeFontSize"
              value={printSettingData.largeFontSize}
              onChange={handlePrintSettingChange}
              placeholder="Enter Large Font Size"
            />
          </div>
          <div className="col-md-12">
            <label className="form-label">Page Width (MM)</label>
            <input
              type="text"
              className="form-control"
              name="pageWidth"
              value={printSettingData.pageWidth}
              onChange={handlePrintSettingChange}
              placeholder="Enter Page Width"
            />
          </div>
  <div className="col-md-12">
  <div className="form-check form-switch mt-2">
    <input
      className="form-check-input"
      type="checkbox"
      id="anlookActive"
      name="anlookActive"
      checked={printSettingData.anlookActive}
      onChange={handlePrintSettingChange}
    />
    <label className="form-check-label" htmlFor="anlookActive">
      Activate Anlook Printing Software
    </label>
  </div>
</div>

<div className="col-md-12">
  <div className="form-check form-switch mt-2">
    <input
      className="form-check-input"
      type="checkbox"
      id="autoPrint"
      name="autoPrint"
      checked={printSettingData.autoPrint}
      onChange={handlePrintSettingChange}
    />
    <label className="form-check-label" htmlFor="autoPrint">
      Enable Auto Printing (disable for One-Click)
    </label>
  </div>
</div>
        </div>

        <div>
          <button
            className="btn btn-success mt-4"
            onClick={handleUpdatePrintSetting}
            disabled={loading}
          >
            {loading ? "Updating..." : "Save"}
          </button>
        </div>
      </div>
    </div>

    {/* Right Column */}
    <div className="col-6 d-flex flex-column align-items-center justify-content-center">
      <div className="bg-light rounded border p-4 text-center d-flex align-items-center gap-4 w-100">
        <h4 className="fw-bold">Anlook Auto Printing Software</h4>
        <div className="position-relative d-inline-block shadow single-line-css">
          <a
            href="https://drive.google.com/drive/folders/1e6_CaxQnLNx0D96IqAlKFEc0erspm_IK?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-success px-4 py-2 fs-5"
          >
            Download Now
          </a>
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark"
            style={{ fontSize: '0.75rem' }}
            title="New Feature"
          >
            NEW
          </span>
        </div>
      </div>

      <div className="card bg-light mt-4 shadow-sm border-0 w-100">
        <div className="card-body px-4 px-md-5 py-4">
          <h4 className="fw-bold mb-4 text-primary text-center">Step-by-Step Installation Guide</h4>
          <ol className="fs-5 text-muted">
            <li className="mb-4">
              <strong>Download the Software:</strong><br />
              Click the green <span className="text-success fw-semibold">“Download Now”</span> button above to get the ZIP file from Google Drive.
            </li>
            <li className="mb-4">
              <strong>Extract the ZIP File:</strong><br />
              Right-click the ZIP file and choose <em>"Extract All..."</em> or use any unzipping tool.
            </li>
            <li className="mb-4">
              <strong>Run the Software:</strong><br />
              Open the folder and double-click <code>AnlookAutoPrint.exe</code>. It runs silently in the background.
            </li>
            <li className="mb-4">
              <strong>Set to Auto-Start (Optional):</strong><br />
              Contact our support team if you'd like help setting this up.
            </li>
            <li className="mb-2">
              <strong>Done!</strong><br />
              Your receipts will now print automatically!
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
)}

              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderSettings;
